import React from "react";

import { PayrollRunDetailsEmployee } from "../../components/PayrollRunDetailsEmployee";
import {
  PayrollRunsYear,
  routeHelperPayrollRunsDashboard,
  routeHelperPayrollRunsDetails
} from "../../paths";

/**
 * The employee payroll surface's run detail page. This wrapper only supplies
 * what the route knows: the year the dashboard is on, for the breadcrumb and for
 * where to land after the run is deleted.
 */
export const RoutePayrollRunsDetails: React.FC = () => {
  const goToDashboard = routeHelperPayrollRunsDashboard.useGoTo();
  const {
    params: { year: yearParam, payrollRunId }
  } = routeHelperPayrollRunsDetails.useData();
  const year = yearParam as PayrollRunsYear;

  return (
    <PayrollRunDetailsEmployee
      breadcrumbs={[
        {
          label: "Payroll runs",
          onClick: () => goToDashboard({ year })
        }
      ]}
      payrollRunId={payrollRunId}
      onDeleted={() => goToDashboard({ year })}
    />
  );
};
